import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { ErrorBoundary, postData } from './components/misc';
import './customAlert';
import './utils/posthog';
import { trackNewVisitorFromUtm } from './utils/visitorTracking';

trackNewVisitorFromUtm();

// Apply the saved theme before rendering so CSS variables are available immediately.
import { applyThemeToDocument, getCurrentTheme } from './utils/language';


const version = "1.0.2"; // Version of the app

// Global error handlers
window.onerror = function (message, source, lineno, colno, error) {
  postData('/api/log-error', {
      type: `GlobalError ${version}`,
      message,
      source,
      lineno,
      colno,
      stack: error?.stack || null,
  }).catch((error) => {
    console.log('Error logging: ', error);
  });
};

window.onunhandledrejection = function (event) {
  postData('/api/log-error', {
      type: `UnhandledPromiseRejection ${version}`,
      message: event.reason?.message || String(event.reason),
      stack: event.reason?.stack || null,
  }).catch((error) => {
    console.log('Error logging unhandled rejection:', error);
  });
};

const rootElement = document.getElementById('mainrender');

// Create a root using ReactDOM's createRoot (new in React 18)
const root = ReactDOM.createRoot(rootElement);


// Apply the current theme before React mounts.
applyThemeToDocument(getCurrentTheme());

// Render the App component inside the root element
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <ErrorBoundary version={version}>
        <App />
      </ErrorBoundary>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

import('./sentryDeferred');
